import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Season2/new_whalepool_02.png")